import { defineStore } from "pinia";

export const useAppStore = defineStore("counter", {
  state: () => {
    return {
      showNav: false,
    };
  },

  actions: {
    toggleNav() {
      this.showNav = !this.showNav;
    },
    disableNav() {
      this.showNav = false;
    },
    scrollToSection(id: string) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      });
      this.disableNav();
    },
  },
});
